import { createStyles, makeStyles } from "@material-ui/styles";

import { RelodeTheme } from "../../../";

export const useNoteContainerStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                height: "100%",
                position: "absolute",
                overflow: "hidden",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: "flex",
                flexDirection: "column",
                [theme.breakpoints.down("md")]: {
                    maxHeight: "85%",
                    marginTop: "auto",
                },
                [theme.breakpoints.down("sm")]: {
                    maxHeight: "80%",
                    marginTop: "auto",
                },
            },
            list: {
                position: "relative",
                overflow: "auto",
                height: "100%",
                padding: theme.spacing(2),
            },
            bottomFade: {
                zIndex: 899,
                height: 16,
                boxShadow:
                    "0 -3px 6px rgba(0,0,0,0.16), 0 -3px 6px rgba(0,0,0,0.23)",
                userSelect: "none",
                position: "absolute",
                bottom: 134,
                left: 0,
                right: 0,
                transition: theme.transitions.create(["height"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            composer: {
                zIndex: 900,
                backgroundColor: theme.relode.colors.pageSecondaryBackground,
                boxShadow:
                    "0px -2px 4px -1px rgba(0, 0, 0, 0.2), 0px -4px 5px 0px rgba(0, 0, 0, 0.14)",
                transition: theme.transitions.create(["box-shadow"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            hideBottomShadow: {
                boxShadow:
                    "0px -2px 4px -1px rgba(0, 0, 0, 0), 0px -4px 5px 0px rgba(0, 0, 0, 0)",
                transition: theme.transitions.create(["box-shadow"], {
                    easing: theme.transitions.easing.easeIn,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
        }),
    { name: "NoteContainer" }
);

export const useNoteListStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                paddingTop: 8,
                display: "grid",
                gridTemplateColumns: "1fr",
                gridRowGap: 8,
            },
        }),
    { name: "NoteList" }
);

export const useNoteStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
                minWidth: 266,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                marginBottom: theme.spacing(2),
            },
            subject: {
                marginBottom: theme.spacing(2),
            },
            audit: {
                display: "flex",
                justifyContent: "space-between",
                marginBottom: theme.spacing(1),
                fontSize: "14px",
                color: theme.relode.colors.backgroundText.main,
                opacity: 0.7,
            },
            body: {
                fontSize: "16px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                marginBottom: theme.spacing(3),
            },
        }),
    { name: "Note" }
);

export const useNoteComposerStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                minWidth: 266,
            },
            entry: {
                margin: "0 8px",
            },
            button: {
                margin: "-8px 8px 4px",
                display: "flex",
                justifyContent: "flex-end",
            },
            mobileButton: {
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: theme.spacing(1),
                display: "flex",
                justifyContent: "center",
                height: theme.spacing(4),
                width: "90vw",
            },
        }),
    { name: "NoteComposer" }
);
